import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useApi } from '../../../../../hooks/useApi';
import { useProfile } from '@/context';
import Swal from 'sweetalert2';
import { Grid } from 'gridjs-react';
import { columnsData } from './columns';

const ListMandatorySaving = () => {
  const api = useApi();
  const navigate = useNavigate();
  const { profile } = useProfile();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  });

  // Load data when profile is available
  useEffect(() => {
    if (profile?.cooperative?.id) {
      fetchMandatory();
    }
  }, [profile?.cooperative?.id]);

  const fetchMandatory = async (page = pagination.page) => {
    if (!profile?.cooperative?.id) return;
    
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pagination.limit.toString()
      });
      
      const cooperativeId = profile.cooperative.id;
      const response = await api.get(`/cooperatives/${cooperativeId}/savings-accounts?type=mandatory&${params}`);
      
      if (response && response.data) {
        setList(response.data);
        setPagination(prev => ({
          ...prev,
          page: response.pagination?.current_page || page,
          total: response.pagination?.total || 0,
          totalPages: response.pagination?.total_pages || 1
        }));
      } else {
        setList([]);
      }
    } catch (error) {
      console.error('Failed to load orders:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load orders. Please try again.'
      });
      setList([]);
    } finally {
      setLoading(false);
      setInitialLoad(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      loadOrders(newPage);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <>
        <nav className="flex mb-6" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-3">
                <li className="inline-flex items-center">
                    <Link 
                        to="/dashboard"
                        className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
                    >
                        <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                        </svg>
                        Dashboard
                    </Link>
                </li>
                <li>
                    <div className="flex items-center">
                        <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                        </svg>
                        <button
                            onClick={() => navigate('/admin/list-mandatory-savings')}
                            className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
                        >
                            List Simpanan Wajib
                        </button>
                    </div>
                </li>
            </ol>
        </nav>
      
      <div className="flex flex-auto flex-col">
        <div className="card">
          <div className="card-header">
            <div className="flex justify-between items-center">
              <h4 className="card-title">List Simpanan Wajib</h4>
              <div className="flex gap-2">
                <button 
                  className="btn btn-sm bg-secondary text-white"
                  onClick={() => loadOrders(1)}
                  disabled={loading}
                >
                  <i className="mgc_refresh_1_line me-2"></i>Refresh
                </button>
                <button className="btn btn-sm bg-info text-white">
                  <i className="mgc_filter_line me-2"></i>Filter
                </button>
              </div>
            </div>
          </div>
          
          <div className="p-6">
            {initialLoad && loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
              </div>
            ) : (
              <div className="overflow-x-auto relative">
                {loading && !initialLoad && (
                  <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                  </div>
                )}
                <Grid
                data={list}
                columns={columnsData(navigate)}
                pagination={true}
                search={{
                  placeholder: 'Cari...'
                }}
                sort={true}
                language={{
                  search: {
                    placeholder: 'Cari...'
                  },
                  pagination: {
                    previous: 'Sebelumnya',
                    next: 'Selanjutnya',
                    showing: 'Menampilkan',
                    to: 'sampai',
                    of: 'dari',
                    results: 'hasil'
                  },
                  loading: 'Memuat...',
                  noRecordsFound: 'Tidak ada data ditemukan',
                  error: 'Terjadi kesalahan saat memuat data'
                }}
              />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ListMandatorySaving;
